import React from "react";
import { Menu } from "@headlessui/react";

function DropdowItem({ title, icon, onClick }) {
  return (
    <Menu.Item onClick={() => onClick()}>
      {({ active }) => (
        <button
          className={`${
            active ? "bg-primary text-white" : "text-gray-900"
          } animate group flex w-full items-center space-x-2 rounded-md px-2 py-2 text-sm text-secondary hover:text-white`}
        >
          {icon}
          <span className="font-nunito text-sm  font-normal ">{title}</span>
        </button>
      )}
    </Menu.Item>
  );
}

export default DropdowItem;
